module.exports = __webpack_public_path__ + "img/location1.b2ea72d8.png";